import { useSetRecoilState } from 'recoil';
import { authAtom } from './AuthState';
import { useAxiosWrapper } from '../../services/axiosWrapper';
import { history } from '../../helpers/history';
import { useBaseActions } from '../base.actions';
import { useTranslation } from '../../commons/useTranslasion';

function useUsuarioActions() {
  const baseActions = useBaseActions('', authAtom, true);
  const baseUrl = `${process.env.REACT_APP_API_URL}/v1/assessorados`;
  const axiosWrapper = useAxiosWrapper();
  const setAuth = useSetRecoilState(authAtom);
  const { changeLanguage } = useTranslation();

  return {
    login,
    logout,
    update,
    completeLogin,
    get: baseActions.get,
    list: baseActions.list,
  };

  async function login(usuario: string, senha: string) {
    try {
      const response = await axiosWrapper.post(`${baseUrl}/autenticacao`, {
        usuario,
        senha,
      });

      // Se retornou uma lista de usuários
      if (Array.isArray(response)) {
        // Se há apenas um usuário, faz login direto
        if (response.length === 1) {
          completeLogin(response[0]);
          return { multipleUnits: false, usuario: response[0] };
        }
        // Se há múltiplos usuários, mostra dialog de seleção
        return { multipleUnits: true, usuarios: response };
      }

      // Se retornou um único usuário
      const user = response;
      completeLogin(user);
      return { multipleUnits: false, usuario: user };
    } catch (e: any) {
      throw e;
    }
  }

  function completeLogin(user: any) {
    localStorage.setItem('usuario', JSON.stringify(user));
    setAuth(user);
    const idiomaUnidadeOperacional = user?.idioma;
    switch (idiomaUnidadeOperacional) {
      case 'es_AR':
        changeLanguage('es-ar');
        break;
      default:
        changeLanguage('pt-br');
        break;
    }

    const { from } = (history?.location?.state as any) || {
      from: { pathname: '/' },
    };
    history.push(from);
  }

  function logout() {
    localStorage.removeItem('usuario');
    setAuth(null);

    history.push('/login');
  }

  async function update(id: number, obj: object) {
    try {
      const recurso = await axiosWrapper.put(`${baseUrl}/${id}`, obj);
      return recurso;
    } catch (error) {
      if (error === 'Usuário inválido') {
        localStorage.removeItem('usuario');
        setAuth(null);
        history.push('/login');
      }
      throw error;
    }
  }
}

export { useUsuarioActions };
